import { Link } from 'react-router';
import {
  Center,
  Column,
  CustomSpinner,
  EmptyScreen,
  Icon,
  Pagination,
  Row,
  Text,
} from '~/commonComponents';
import { EmptyShiftPendingReview } from '~/images/icons';
import { Colors } from '~/themes/colors';
import { Table } from './components/Table';
import { usePendingShiftReviews } from './hooks';

interface IProps {
  isCompact?: boolean;
}

export const ShiftPendingReviews = ({ isCompact = false }: IProps) => {
  const { data, isInitialLoading, isLoading, page, total, onPageChanged } = usePendingShiftReviews({
    limit: isCompact ? 5 : 10,
  });

  if (isInitialLoading) {
    return <CustomSpinner isLoading />;
  }

  if (data.length === 0 && !isLoading) {
    return (
      <Column paddingBottom={64}>
        <EmptyScreen
          Icon={() => <EmptyShiftPendingReview />}
          title="You’re all caught up!"
          description="All shift confirmations and adjustments are up to date. We’ll update this after your next shift ends."
          descriptionStyle={{
            textAlign: 'center',
          }}
        />
      </Column>
    );
  }

  return (
    <Column>
      <Table data={data} isLoading={isLoading} />
      {isCompact ? (
        <Link
          to="/dashboard/jobs/pending-reviews"
          style={{
            textDecoration: 'none',
            cursor: 'pointer',
            marginRight: 12,
          }}
        >
          <Row alignItems="center" gap={14} justifyContent="end" paddingBottom={16} paddingTop={24}>
            <Text bold color={Colors.secondary_500} fontSize={18}>
              View All
            </Text>
            <Icon name="arrow-right" size={24} />
          </Row>
        </Link>
      ) : (
        <Center paddingVertical={24}>
          <Pagination
            currentPage={page}
            onPageChange={onPageChanged}
            totalPages={Math.ceil(total / (isCompact ? 5 : 10))}
          />
        </Center>
      )}
    </Column>
  );
};
